import styled from "styled-components";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track, transparent);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--accent, #6b8f71);
    border-radius: 10px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-width: none;
  padding: 1.25rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  box-sizing: border-box;
  overflow: visible;

  @media screen and (max-width: 768px) {
    padding: 3.5rem 0.75rem 2rem;
  }
`;

export const HeaderSection = styled.header`
  width: 100%;
  flex-shrink: 0;
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0 1.5rem;
  padding: 1.5rem;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-subtle);
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  position: relative;
  overflow: visible;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
  }
`;

export const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1.25rem;
`;

export const Subtitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-heading);
  margin: 0 0 0.5rem;
  letter-spacing: 0.02em;
  opacity: 0.95;
  width: 100%;
  flex: 0 0 100%;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.25rem;
  width: calc(50% - 0.75rem);
  box-sizing: border-box;
  flex: 0 0 auto;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.25rem;
  width: calc(50% - 0.75rem);
  box-sizing: border-box;
  flex: 0 0 auto;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin-bottom: 1rem;
  box-sizing: border-box;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.45rem;
  display: block;
  position: relative;
  z-index: 2;
`;

/** Mesmo padrão de altura/padding dos inputs da plataforma (busca, usuários). */
export const ShowInput = styled.input`
  width: 100%;
  min-height: 44px;
  height: 44px;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;
  box-sizing: border-box;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  &:read-only {
    cursor: default;
  }
`;

export const StyledSelect = styled.select`
  width: 100%;
  min-height: 44px;
  height: 44px;
  padding: 0.75rem 2.5rem 0.75rem 1rem;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background-color: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  text-align: left;
  direction: ltr;
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--text-heading) 50%),
    linear-gradient(135deg, var(--text-heading) 50%, transparent 50%);
  background-repeat: no-repeat;
  background-position: calc(100% - 18px) calc(50% - 2px), calc(100% - 13px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;

  option {
    background: var(--surface-overlay);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background-color: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }
`;

export const Divider = styled.hr`
  width: 100%;
  flex: 0 0 100%;
  height: 1px;
  background-color: var(--border-default);
  border: none;
  margin: 1rem 0 1.25rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-left: auto;
  position: relative;
  z-index: 2;
  gap: 0.75rem;

  @media screen and (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    justify-content: stretch;
  }
`;

export const StyledButton = styled.button`
  background: ${(props) =>
    props.secondary ? "var(--input-bg)" : "var(--accent-secondary-soft)"};
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: ${(props) =>
    props.secondary ? "var(--text-primary)" : "var(--text-heading)"};
  cursor: pointer;
  padding: 10px 20px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 42px;
  z-index: 2;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    border-color: ${(props) =>
      props.secondary ? "var(--text-muted)" : "var(--accent)"};
    color: var(--text-primary);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;
